// The board's pure model moved to @d-orca/shared/client/logistics (mobile's
// pager reads it too); the dnd-kit and web-error halves stay here.
export {
  DELIVERED_WINDOW_DAYS, isOverdue, isOverdueOn, arrivalVerdict, overdueDays, groupDeliveries, countByStatus,
  columnCards, criticalFirst, sortColumnCards, sortDeliveredCards, partitionDelivered, stackDelivered,
  displayStatusName, moveCardErrorTitleKey, type IColumnCard,
} from '@d-orca/shared/client/logistics';

/** The `data` payload the board's dnd-kit draggables/droppables carry. Shared
 *  so the producers (`BoardCard`, `BoardColumn`) and the consumer
 *  (`DeliveryBoard`) agree on one shape instead of three untyped literals a
 *  rename could silently split. */
export type DragData =
  | { type: 'card'; ref: string }
  | { type: 'column'; statusId: string };

/** Narrow dnd-kit's loose `data.current` (`Record<string, unknown>`) to a
 *  `DragData`, checking the discriminant AND its field at runtime — so a
 *  malformed payload becomes `undefined` rather than a mis-typed access. */
export function readDragData(data: Record<string, unknown> | undefined): DragData | undefined {
  if (data?.type === 'card' && typeof data.ref === 'string') return { type: 'card', ref: data.ref };
  if (data?.type === 'column' && typeof data.statusId === 'string')
    return { type: 'column', statusId: data.statusId };
  return undefined;
}

/** The card's / drawer's stylesheet class for each verdict tone — one mapping
 *  for both surfaces, every tone named (early is grey, not a fall-through). */
export const VERDICT_TONE_CLASS = {
  onTime: 'varOnTime',
  early: 'varEarly',
  late: 'varLate',
} as const satisfies Record<'onTime' | 'early' | 'late', string>;

/** Column-reorder reducer for dnd-kit's DragEnd — pure so it is testable
 *  without pointer gestures (jsdom cannot drive PointerSensor). */
export function applyColumnDrag(order: string[], activeId: string, overId: string): string[] {
  const from = order.indexOf(activeId);
  const to = order.indexOf(overId);
  if (from < 0 || to < 0 || from === to) return order;
  const next = [...order];
  next.splice(to, 0, ...next.splice(from, 1));
  return next;
}

